import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class ToasterService {
    private bannerToasts: Toast[] = [];
    private modalToast: ModalToast = NULL_MODAL_TOAST;
    private _bannerSubject: BehaviorSubject<Toast[]> = new BehaviorSubject<Toast[]>(this.bannerToasts);
    private _modalToastSubject: BehaviorSubject<ModalToast> = new BehaviorSubject<ModalToast>(this.modalToast);

    public bannerToast$: Observable<Toast[]> = this._bannerSubject.asObservable();
    public modalToast$: Observable<ModalToast> = this._modalToastSubject.asObservable();

    public showBanner(type: ToastType, title?: string, body?: string, delay?: number) {
        const toast: Toast = {
            id: this.bannerToasts.length + 1,
            title: title,
            body: body,
            type,
            delay
        } as Toast;
        this.bannerToasts.push(toast);
        this._bannerSubject.next(this.bannerToasts);

        // Automatically remove the toast after the specified delay
        if (toast.delay) {
            setTimeout(() => {
                this.removeBanner(toast.id);
            }, toast.delay || 6000);
        }
    }

    public showModal(type: ToastType, title?: string, body?: string) {
        const toastModal: ModalToast = {
            title: title,
            body: body,
            type:type,
        } as ModalToast;
        this.modalToast = toastModal;
        this._modalToastSubject.next(this.modalToast);
    }


    public removeModal() {
        this._modalToastSubject.next(this.modalToast);
    }
    
    public removeBanner(id: number) {
        this.bannerToasts = this.bannerToasts.filter(toast => toast.id !== id);
        this._bannerSubject.next(this.bannerToasts);
    }
}

export enum ToastType {
    Info = 'info',
    Success = 'success',
    Error = 'error',
    Warning = 'warning'
}

export const NULL_TOAST = { title: '_____NULL_____' } as Toast;
export const NULL_MODAL_TOAST = { title: '_____NULL_____' } as ModalToast;


export interface Toast {
    id: number;
    type: ToastType;
    title: string;
    body: string;
    delay: number;
}

export interface ModalToast {
    type: ToastType;
    title: string;
    body: string;
}